import cx from 'classnames';
import styles from './AnimatedDotsText.module.scss';

import { FC } from 'react';
import { Typography, TypographyTypes, TypographyVariants } from '../Typography';

interface AnimatedDotsTextProps {
  text: string;
  className?: string;
  animated?: boolean;
  classNameText?: string;
  component?: TypographyTypes;
  variantText?: TypographyVariants;
}

export const AnimatedDotsText: FC<AnimatedDotsTextProps> = ({
  text,
  className,
  classNameText,
  animated = true,
  component = 'h3',
  variantText = 'primary',
}) => {
  return (
    <div className={cx(styles.adtContainer, className)}>
      <Typography component={component} variant={variantText} textTransform="uppercase">
        {text}
      </Typography>
      <Typography
        component={component}
        variant={variantText}
        className={cx(classNameText, animated ? styles.loadingDots : '')}
      >
        ...
      </Typography>
    </div>
  );
};
